<button
  data-test="invite-person-button"
  class="btn btn-primary max-content"
  type="button"
  (click)="openModalSearchCoupon()"
>
  {{ 'button_labels.activate_coupon' | translate }}
</button>